module.exports = __webpack_public_path__ + "static/media/AWS-Network-Spec.7c4b97aa.png";